import * as React from 'react'
import { BasePage } from 'app/shared/components/base/BasePage'
import { Button } from 'primereact/button'
import { useToast } from 'app/shared/context/CommonUIProvider'
import DialogCustom from 'app/shared/components/Dialog'
import { CopyToClipboard } from 'react-copy-to-clipboard'

//팝업이미지
import PopupImg from 'assets/images/common/img-qr-web.png'
import { PopupComponentProps } from 'app/core/models/component/popupComponent'

/*======================================================================
 * @ 업무설명 : 모바일이용안내팝업
 * @ 파 일 명 : /app/pages/etc/evt/ETCEVT0102.tsx
 * @ 화 면 ID : SC-ETC-7000-P
 * @ ASIS :
 *======================================================================
 * 번호  작업자           작업일         변경내용
 *======================================================================
 * 1     김상돈(S24069)   2025.07.25     최초작성
 *======================================================================
 */
const ETCINF0101: React.FC<PopupComponentProps> = (props) => {
    // 모바일 안내팝업
    const { show: toastShow, hide: toastHide } = useToast()

    return (
        <DialogCustom
            visible={props.visible}
            className="dialog-alert web-popup"
            backClose={false}
            onClose={props.onClose}
            footer={
                <CopyToClipboard
                    text={window.location.origin}
                    onCopy={() => {
                        toastShow({
                            severity: 'success',
                            content: 'IBK 모바일브랜치 주소를 복사했어요.',
                        })
                        props.onClose()
                    }}
                >
                    <Button
                        label="IBK 모바일브랜치 주소 복사하기"
                        className="button-basic-primary -md width-full"
                    />
                </CopyToClipboard>
            }
        >
            <img src={PopupImg} alt="" />
            <p className="h6 bold mt-24">모바일웹에서 이용해주세요</p>
            <p className="mt-08">
                IBK 모바일브랜치에서
                <br />
                다양한 혜택과 정보를 확인해주세요.
            </p>
        </DialogCustom>
    )
}

export default ETCINF0101
